// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3fe95b3b","688":"6beec09c"}[chunkId] + ".chunk.js";
};